


























import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import { ClaimEnum } from '../../services/ClaimEnum';

@Component
export default class SmsCreditLeftWidget extends Vue {
    smsCreditLeft: number = null;
    loading: boolean = false;
    threshold: number = 100;

    badgeIcon: string = null;
    badgeVariant: string = null;
    badgeTitle: string = null;

    get isAuthorized(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanAdmin);
    }

    setBadgeCustomization() {
        if(this.smsCreditLeft > this.threshold) {
            this.badgeVariant = "success";
            this.badgeIcon = "fa fa-check-circle";
        }
        else if(this.smsCreditLeft == 0) {
            this.badgeVariant = "danger";
            this.badgeIcon = "fa fa-ban";
            this.badgeTitle = "SMS sender JOB has used all sms credits available";
        }
        else {
            this.badgeVariant = "warning";
            this.badgeIcon = "fa fa-exclamation-circle";
            this.badgeTitle = "SMS sender JOB has reached set threshold of sms credits";
        }
    }

    async mounted() {
        if (this.isAuthorized) {
            await this.refresh();
        } 
    }

    async refresh() {
        try {
            
            this.loading = true;
            let results: any = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/utils/GetSmsCreditLeftMainVar'),
                withCredentials: true,
                responseType: 'json'
            });

            if(results.data) {
                this.smsCreditLeft = results.data;
                this.setBadgeCustomization();
            }
        } catch (error) {
            General.HandleError(error, this);
        } finally {               
            this.loading = false;
        }
    }
}
